import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
export const NotificationRecipientSchema = z.discriminatedUnion('type', [
    z.object({
        id: z.string(),
        type: z.literal('member'),
        userId: z.string(),
        email: z.string().nullable(),
        enabled: z.boolean(),
    }),
    z.object({
        id: z.string(),
        type: z.literal('custom'),
        email: z.string(),
        enabled: z.boolean(),
    }),
]);
export const NotificationSettingsSchema = z.object({
    organizationId: z.string(),
    emailEnabled: z.boolean(),
    recipients: z.array(NotificationRecipientSchema),
});
export const NotificationRecipientInputSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('member'),
        userId: z.string().min(1, 'userId is required'),
        enabled: z.boolean().default(true),
    }),
    z.object({
        type: z.literal('custom'),
        email: z.string().email('email must be a valid email address'),
        enabled: z.boolean().default(true),
    }),
]);
/** Replace semantics: `recipients` becomes the whole recipient list. */
export const UpdateNotificationSettingsBodySchema = z.object({
    emailEnabled: z.boolean(),
    recipients: z.array(NotificationRecipientInputSchema).default([]),
});
export const notificationSettingsContract = c.router({
    getNotificationSettings: {
        method: 'GET',
        path: '/organizations/:organizationId/notification-settings',
        pathParams: z.object({ organizationId: z.string().min(1) }),
        responses: {
            200: NotificationSettingsSchema,
        },
        summary: 'Get the notification settings of an organization',
    },
    updateNotificationSettings: {
        method: 'PUT',
        path: '/organizations/:organizationId/notification-settings',
        pathParams: z.object({ organizationId: z.string().min(1) }),
        body: UpdateNotificationSettingsBodySchema,
        responses: {
            200: NotificationSettingsSchema,
        },
        summary: 'Replace the notification settings of an organization',
    },
});
